import React, { useState } from 'react';
import { getItemTypeTranslation, getTypeIcon } from '../../utils/itemTranslations';

const EQUIPMENT_TYPES = ['WEAPON', 'ARMOR', 'ROBE', 'SHIELD'];
const SET_TYPES = ['BOOTS', 'GLOVES', 'BRACELET', 'ACCESSORY'];
const MAIN_RELIC_NAMES = ['Yag', 'Babel', 'Draxos', 'Midranda'];

// Tooltip com equipamentos, set e relíquias de um personagem, exibido ao passar o mouse
const CharacterInfoTooltip = ({ character, children }) => {
  const [visible, setVisible] = useState(false);

  const items = character?.items || [];
  const relics = (character?.relics || []).filter((cr) =>
    MAIN_RELIC_NAMES.some((name) => cr.relic?.name?.includes(name))
  );

  const equipment = items.filter((ci) => EQUIPMENT_TYPES.includes(ci.item?.type));
  const set = items.filter((ci) => SET_TYPES.includes(ci.item?.type));
  const hasInfo = equipment.length > 0 || set.length > 0 || relics.length > 0;

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}

      {visible && (
        <div className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 p-3 rounded-lg bg-slate-900 border border-white/20 shadow-xl pointer-events-none">
          <div className="absolute left-1/2 -translate-x-1/2 top-full -mt-1 w-2 h-2 bg-slate-900 border-r border-b border-white/20 rotate-45" />

          {!hasInfo ? (
            <p className="text-xs text-gray-400">Sem informações de equipamentos, set ou relíquias</p>
          ) : (
            <div className="space-y-2 text-left">
              {equipment.length > 0 && (
                <div>
                  <p className="text-xs font-semibold text-cyan-400 mb-1">⚔️ Equipamentos</p>
                  {equipment.map((ci, idx) => (
                    <p key={idx} className="text-xs text-gray-300 truncate">
                      {getTypeIcon(ci.item?.type)} {ci.item?.name}
                      {typeof ci.enhancement === 'number' && (
                        <span className="text-purple-400"> +{ci.enhancement}</span>
                      )}
                    </p>
                  ))}
                </div>
              )}

              {set.length > 0 && (
                <div>
                  <p className="text-xs font-semibold text-emerald-400 mb-1">💎 Set</p>
                  {set.map((ci, idx) => (
                    <p key={idx} className="text-xs text-gray-300 truncate">
                      {getTypeIcon(ci.item?.type)} {getItemTypeTranslation(ci.item?.type)}: {ci.item?.name}
                      {typeof ci.enhancement === 'number' && (
                        <span className="text-purple-400"> +{ci.enhancement}</span>
                      )}
                    </p>
                  ))}
                </div>
              )}

              {relics.length > 0 && (
                <div>
                  <p className="text-xs font-semibold text-amber-400 mb-1">🏺 Relíquias</p>
                  {relics.map((cr, idx) => (
                    <p key={idx} className="text-xs text-gray-300 truncate">
                      {cr.relic?.name}
                    </p>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CharacterInfoTooltip;
